import React from 'react';

import {REMOTE_CONFIG_PATHS} from '../../../constants/remoteConfigPaths';
import {DynamicContent} from '../../DynamicContent';

export const DisacceptanceEc = () => {
  return (
    <DynamicContent
      configPath={REMOTE_CONFIG_PATHS.MERCHANT_POLICY.SECTIONS.DISACCEPTANCE_EC}
      renderAsHtml={true}
    />
  );
};
